import type * as lazyIndex from './lazyIndex';
import { LazyModule, createLazyComponent, type LazyComponent } from 'owa-bundling';
import { default as MeControlPlaceholder } from './components/MeControlPlaceholder';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaPreactMeControl" */ './lazyIndex'),
    { name: 'OwaPreactMeControl' }
);

export const LazyMeControl: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.MeControl,
    MeControlPlaceholder
);
